import { render, staticRenderFns } from "./ListCodigosPromocionaisConvenio.vue?vue&type=template&id=16567255&"
import script from "./ListCodigosPromocionaisConvenio.vue?vue&type=script&lang=js&"
export * from "./ListCodigosPromocionaisConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports